import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Action } from "shared/types/Action"
import {
  ActionButtons,
  ActionButtonsStyle
} from "shared/ui/action-buttons/ActionButtons"
import { ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_installation-reference-product-info.scss"

export interface InstallationReferenceProductInfoViewModel {
  title: string
  productKind: string
  image: React.ReactNode
  description: React.ReactNode
  roomTypes: string[]
  onNavigateToProduct: () => void
  onCopyLink: () => void
}

export const InstallationReferenceProductInfoView = React.memo(
  ({
    title,
    productKind,
    image,
    onNavigateToProduct,
    onCopyLink
  }: InstallationReferenceProductInfoViewModel) => {
    const { t } = useTranslation()

    const actions: Action[] = useMemo(
      () =>
        [
          {
            key: "copy-link",
            label: t("General.CopyItem", {
              item: t("InstallationReference.Link")
            }),
            icon: IconName.DUPLICATE,
            onClick: onCopyLink,
            variant: ButtonVariant.SECONDARY
          },
          {
            key: "navigate-to-product",
            label: t("Product.OpenPage"),
            icon: IconName.PRODUCTS,
            onClick: onNavigateToProduct,
            className:
              "installation-reference-product-info__navigate-to-product",
            variant: ButtonVariant.PRIMARY
          }
        ] as Action[],
      [onNavigateToProduct, onCopyLink]
    )

    return (
      <div className="installation-reference-product-info">
        <div className="installation-reference-product-info__main card card--elevated">
          <div className="installation-reference-product-info__header">
            <h4 className="installation-reference-product-info__product-kind">
              {productKind}
            </h4>
            <div className="installation-reference-product-info__title">
              {title}
            </div>
          </div>
          <div className="installation-reference-product-info__image">
            {image}
          </div>
        </div>
        <ActionButtons
          className={classNames("installation-reference-product-info__actions")}
          data-testid="installation-reference-product-info__actions"
          actions={actions}
          actionButtonsStyle={ActionButtonsStyle.TOOLBAR}
        />
      </div>
    )
  }
)
